import { render, staticRenderFns } from "./additionalDataTab.vue?vue&type=template&id=2951f954&scoped=true&"
import script from "./additionalDataTab.vue?vue&type=script&lang=js&"
export * from "./additionalDataTab.vue?vue&type=script&lang=js&"
import style0 from "./additionalDataTab.vue?vue&type=style&index=0&id=2951f954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951f954",
  null
  
)

export default component.exports